import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { Map } from 'immutable';

import config from '../../config';
import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { MailingSummary } from '../MailingSummary';
import { GridCard } from '../helpers/GridCard';
import { MailingLogsTable } from './MailingLogsTable';
import { AttachmentRenderer } from './AttachmentRenderer';

import style from './style.module.css';

const columnDefs = config.mailingLogs.getIn(['table', 'columnDefs']);

/**
 * Mailing logs page component.
 */
const MailingLogsComponent = ({ mailingLogs, mailingInfo, onChange, onGetNextPageData, onReload }) => {
  const processedColumnDefs = useMemo(
    () =>
      columnDefs.map(columnDef => {
        const field = columnDef.get('field');

        switch (field) {
          case 'attachments':
            return columnDef.set('cellRendererFramework', AttachmentRenderer);

          default:
            return columnDef;
        }
      }),
    [],
  );

  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onReload}>
        <i aria-hidden="true" className="fa fa-refresh" /> Reload
      </Button>
    </div>
  );

  return (
    <AppPage overline="Mailing" title="Mailing Logs" toolbar={toolbar}>
      <MailingSummary
        header={mailingInfo.get('header')}
        isEmail={mailingInfo.getIn(['header', 'isemail']) === true}
        showPm
      />
      <GridCard className={style.grid} dense>
        <MailingLogsTable
          columnDefs={processedColumnDefs}
          data={mailingLogs}
          onChange={onChange}
          onGetNextPageData={onGetNextPageData}
        />
      </GridCard>
    </AppPage>
  );
};

MailingLogsComponent.propTypes = {
  mailingLogs: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onGetNextPageData: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
};

export const MailingLogs = memo(MailingLogsComponent);
